export default __webpack_public_path__ + "static/media/13.00c52579.jpg";